import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchLandlord, updateLandlord, uploadDocument, deleteDocument} from '../../actions';
import Logo from './Logo';

import {
    Form,
    Input,
    Button,
    Row,
    Col,
    message,
    Divider,
    Card,
    Tooltip,
    Icon,
    Upload
} from 'antd';
const FormItem = Form.Item;

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {landlord, isFetching} = nextProps;
        if (isFetching || landlord.isFetching) {
            return null;
        }

        if (landlord.error) {
            return {serverErrors: landlord.error}
        }
        if (!landlord.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}} = this;
        if (!serverErrors) {
            this.setState({edit: false});
            Profile.notifySuccess();
            return;
        }

        const {res: {errors, message}} = serverErrors;
        Profile.notifyError(errors || message);
    }
    handleSubmit(e) {
        e.preventDefault();
        const {form, application: {id}, updateLandlord} = this.props;
        return form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            return updateLandlord(id, values).then(() => this.handlePostSubmit(values));
        });
    }

    componentDidMount() {
        const {application: {id}, fetchLandlord} = this.props;
        return fetchLandlord(id);
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const {uploadDocument, deleteDocument} = this.props;
        const {
            id: application,
            business_name,
            address_line_1,
            address_line_2,
            address_line_3,
            post_code,
            contact_name,
            phone_number,
            email: contact_email,
            logo,
        } = this.props.landlord;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 4,
                },
            },
        };

        const toggleEdit = (e) => {
            e.preventDefault();

            this.setState({
                edit: !this.state.edit
            });
        };

        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>Profile Overview</span>
                {!this.state.edit ? (
                    <Tooltip title="Edit Details">
                        <a href="#" onClick={toggleEdit}> <Icon type="edit"/></a>
                    </Tooltip>
                ) : null}
            </div>
        );

        const postUploadHandler = (file, onSuccess, onError) => {
            const {state: {serverErrors}} = this;
            if (!serverErrors) {
                file.status = 'done';
                return onSuccess(file);
            }

            const {res: {errors, message}} = serverErrors;
            file.status = 'error';
            file.response = message;
            Profile.notifyError(errors);
            return onError(file);
        };
        const handleUpload = ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            if (data) {
                Object.keys(data).map(key => {
                    formData.append(key, data[key]);
                });
            }
            formData.append(filename, file);

            return uploadDocument(application, formData).then(() => postUploadHandler(file, onSuccess, onError));
        };
        const onDelete = (doc) => {
            return deleteDocument(application, doc.uid);
        };

        const {edit} = this.state;
        return (
            <Card title={title()} loading={this.props.isFetching} bordered={false}>
                <Row style={{ marginTop: '10px' }} gutter={16}>
                    <Col md={18}>
                        <Form onSubmit={this.handleSubmit.bind(this)} hideRequiredMark={!edit}>
                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label={(
                                    <span>Business Name</span>
                                )}
                            >
                                {getFieldDecorator('business_name', {
                                    initialValue: business_name,
                                    rules: [{ required: true, message: 'Please input your business name!', whitespace: true }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Address Line 1"
                            >
                                {getFieldDecorator('address_line_1', {
                                    initialValue: address_line_1,
                                    rules: [{ required: true, message: 'Please input your address line 1', whitespace: true }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Address Line 2"
                            >
                                {getFieldDecorator('address_line_2', {
                                    initialValue: address_line_2,
                                    rules: [{ required: true, message: 'Please input your address line 2', whitespace: true }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Address Line 3"
                            >
                                {getFieldDecorator('address_line_3', {
                                    initialValue: address_line_3,
                                    rules: [{ required: false, message: 'Please input your address line 3', whitespace: true }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Post Code"
                            >
                                {getFieldDecorator('post_code', {
                                    initialValue: post_code,
                                    normalize: value => {
                                        if (!value) return "";
                                        return value.replace(/[ ]+/g, '')
                                            .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2")
                                            .toUpperCase();
                                    },
                                    rules: [
                                        { pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}', message: 'Invalid post code', transform: value => {
                                            return value.replace(/[ ]+/g, '')
                                                .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2");
                                        }},
                                        { required: true, message: 'Please input your post code', whitespace: true }
                                    ],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <Divider />

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Phone Number"
                            >
                                {getFieldDecorator('phone_number', {
                                    initialValue: phone_number,
                                    rules: [
                                        { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                        { required: true, message: 'Please input your phone number!', whitespace: true }
                                    ],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="E-mail"
                            >
                                {getFieldDecorator('email', {
                                    initialValue: contact_email,
                                    rules: [{
                                        type: 'email', message: 'The input is not valid E-mail!',
                                    }, {
                                        required: true, message: 'Please input your E-mail!', whitespace: true,
                                    }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={edit}
                                {...formItemLayout}
                                label="Main Contact Name"
                            >
                                {getFieldDecorator('contact_name', {
                                    initialValue: contact_name,
                                    rules: [{ required: true, message: 'Please input your main contact name', whitespace: true }],
                                })(
                                    <Input disabled={!edit} className={!edit ? 'input-static': ''}/>
                                )}
                            </FormItem>

                            {edit ? (
                                <FormItem {...tailFormItemLayout}>
                                    <Button size='large' onClick={toggleEdit} style={{marginRight: 10}}>Cancel</Button>
                                    <Button size='large' type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            ) : ''}
                        </Form>
                    </Col>
                    <Col md={6}>
                        <p>Business Logo</p>
                        <Logo logo={logo} onUpload={handleUpload} onRemove={onDelete}/>
                    </Col>
                </Row>
            </Card>
        );
    }
}

const WrappedProfile = Form.create()(Profile);
const mapStateToProps = (state, ownProps) => {
    return {landlord: {...state.landlord.profile}, ...state.me};
};
export default connect(mapStateToProps, {fetchLandlord, updateLandlord, uploadDocument, deleteDocument})(WrappedProfile);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Profile.js